module.exports = __webpack_public_path__ + "img/guess_middle_sel.db80503f.png";